import { render, staticRenderFns } from "./MyTravelInquiries.vue?vue&type=template&id=6ec13cd6&"
import script from "./MyTravelInquiries.vue?vue&type=script&lang=js&"
export * from "./MyTravelInquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports